import { CompleteOperationModalContextType } from '../types/CompleteOperationModalContextType';

export const completeOperationModalInitValue: CompleteOperationModalContextType =
  {
    data: {
      buyerName: '',
      sellerName: '',
      isLoading: false,
    },
    actions: {
      handleConfirm: async () => {},
      handleCloseModal: () => {},
    },
  };
